import { TowingRecordPaymentType } from '../../../../../common/types'
import { PaymentTerminalTransaction } from '../../../../../components/PaymentTerminals/types'

export enum PaymentType {
  person = 'person',
  company = 'company',
  insurance_company = 'insurance_company',
  split = 'split',
  cash = 'cash',
  card = 'card',
  online_payment = 'online_payment',
  settlement = 'settlement',
  aggregate = 'aggregate',
  define_later = 'define_later'
}

export interface BillingInput {
  type: TowingRecordPaymentType | null
  paymentDetails: PaymentDetailsInput
  paymentTerminalTransactions: PaymentTerminalTransaction[]
  status?: BillingStatus
}

export interface PaymentDetailsInput {
  id: number | null
  debtorName: string | null
  receiptEmail: string | null
  debtorPhone: string | null
  paymentDate: Date
  source: string
}

export interface Billing {
  type: PaymentType
  status: BillingStatus
  paymentDetails: PaymentDetails
  paymentTerminalTransactions: PaymentTerminalTransaction[]
}

export interface PaymentDetails {
  id: number
  vatAmout: number
  vatExcludedAmount: number
  vattedAmount: number
  isConfirmed: boolean
  debtorName: string
  receiptEmail: string
  debtorPhone: string
  paymentDate: string
}

export enum BillingStatus {
  draft = 'draft',
  confirmed = 'confirmed',
  sent = 'sent',
  paid = 'paid',
  fully_paid = 'fully_paid',
  open = 'open',
  link_sent = 'link_sent',
  link_expired = 'link_expired',
  payment_failed = 'payment_failed',
  payment_non_trackable = 'payment_non_trackable',
  credited = 'credited',
}

export function isPaymentLinkSent(status?: BillingStatus | string | null): boolean {
  return status === BillingStatus.link_sent || status === BillingStatus.sent
}

export function isPaymentLinkAlreadyActive(
  paymentType?: TowingRecordPaymentType | null,
  billingStatus?: string | null,
): boolean {
  if (paymentType !== TowingRecordPaymentType.online_payment) return false
  const status = billingStatus === 'sent' ? 'link_sent' : billingStatus
  return [BillingStatus.link_sent, BillingStatus.open, BillingStatus.paid, BillingStatus.fully_paid].includes(
    status as BillingStatus,
  )
}

export function isPaymentLinkPaid(
  paymentType?: TowingRecordPaymentType | null,
  billingStatus?: string | null,
): boolean {
  if (paymentType !== TowingRecordPaymentType.online_payment) return false
  const status = billingStatus === 'sent' ? 'link_sent' : billingStatus
  return status === BillingStatus.open || status === BillingStatus.paid || status === BillingStatus.fully_paid
}

export function isTerminalBillingStatus(status?: BillingStatus | string | null): boolean {
  return (
    status === BillingStatus.paid || status === BillingStatus.fully_paid || status === BillingStatus.payment_failed
  )
}

export function isAwaitingPaymentStatus(status?: BillingStatus | string | null): boolean {
  const normalized = status === 'sent' ? 'link_sent' : status
  return normalized === BillingStatus.draft || normalized === BillingStatus.link_sent
}

export interface DeleteBillingFormValues {
  towingRecordId: number
}

export interface DeleteBillingInputMutation {
  towingRecordId: number
}
